"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrejasEpidemicAbilityHandler = exports.FrejasEpidemicActorAbilityFactory = exports.FrejasEpidemicAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class FrejasEpidemicAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.FrejasEpidemic;
        this.__typeName = "FrejasEpidemic";
    }
}
exports.FrejasEpidemicAbilityArgs = FrejasEpidemicAbilityArgs;
let FrejasEpidemicActorAbilityFactory = class FrejasEpidemicActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("FrejasEpidemic", "OneEnemies", 4);
    }
};
FrejasEpidemicActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("FrejasEpidemic")
], FrejasEpidemicActorAbilityFactory);
exports.FrejasEpidemicActorAbilityFactory = FrejasEpidemicActorAbilityFactory;
let FrejasEpidemicAbilityHandler = class FrejasEpidemicAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "GreenMagicBall",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Death", 50)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_1.DiseasedEffectArgs("Power", 10),
                    duration: Duration_1.Duration.Turns(3),
                    sequence,
                    onApplied: (sequence) => {
                        sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet", "behind"), "DarkMagicCircle"));
                    }
                });
                const projectiles = sequence.pushSequence("parallel");
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                    .filter(enemy => enemy !== selectedEnemy)
                    .forEach(enemy => {
                    container.applyProjectileAttackWithDamage({
                        sequence: projectiles.pushSequence("sequential"),
                        abilityKey: ability.args.__typeName,
                        attackType: "ranged_tick",
                        attackerId: ability.invokerId,
                        targetId: enemy,
                        projectileType: "GreenOrb",
                        projectilePath: "line",
                        toApply: [
                            AbilityDamage_1.AbilityDamage.Power("Death", 75)
                        ],
                        onHit(sequence) {
                            container.applyDebuff({
                                attackerId: ability.invokerId,
                                targetId: enemy,
                                effect: new core_1.DiseasedEffectArgs("Power", 10),
                                duration: Duration_1.Duration.Turns(3),
                                sequence
                            });
                        }
                    });
                });
            }
        });
    }
};
FrejasEpidemicAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.FrejasEpidemic)
], FrejasEpidemicAbilityHandler);
exports.FrejasEpidemicAbilityHandler = FrejasEpidemicAbilityHandler;
